import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * Layout route for /serienleistungen. Liste in serienleistungen.index.tsx,
 * Detail in serienleistungen.$id.tsx, Neuanlage in serienleistungen.neu.tsx
 * (Phase 5 Stufe I, Slice 6).
 */
export const Route = createFileRoute('/serienleistungen')({
  component: SerienleistungenLayout,
});

function SerienleistungenLayout(): JSX.Element {
  return <Outlet />;
}
